import { Guid, Nillable } from '@web/utils';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { AdminMultimediaImageUpload } from '@web/shared/module/multimedia';
import { AdminCosmeticStatus } from '../enums';

export class AdminCosmeticAttributes {
  public constructor(
    private readonly data: {
      items: Array<AdminCosmeticAttributeItem>;
    },
  ) {}

  public get items(): Array<AdminCosmeticAttributeItem> {
    return this.data.items;
  }
}

export type AdminCosmeticAttributeItem = {
  content: string;
  id?: Nillable<Guid>;
  productAttributeId: Nillable<Guid>;
};
export type AdminCosmeticAttributeFormGroup = FormGroup<{
  content: FormControl<string>;
  id: FormControl<Nillable<Guid>>;
  productAttributeId: FormControl<Nillable<Guid>>;
}>;
export type AdminCosmeticAttributesFormGroup = FormGroup<{
  attributes: FormArray<AdminCosmeticAttributeFormGroup>;
}>;

export class AdminCosmeticCharacteristics {
  public constructor(
    private readonly data: {
      items: Array<AdminCosmeticCharacteristicItem>;
    },
  ) {}

  public get items(): Array<AdminCosmeticCharacteristicItem> {
    return this.data.items;
  }
}

export type AdminCosmeticCharacteristicItem = {
  content: string;
  id?: Nillable<Guid>;
  label: string;
};
export type AdminCosmeticCharacteristicFormGroup = FormGroup<{
  content: FormControl<string>;
  id: FormControl<Nillable<Guid>>;
  label: FormControl<string>;
}>;
export type AdminCosmeticCharacteristicsFormGroup = FormGroup<{
  characteristics: FormArray<AdminCosmeticCharacteristicFormGroup>;
}>;

export class AdminCosmeticDetailsForm {
  public static VendorUrlMaxLength = 500;
  public static PriceMin = 0;
  public static FilesMinCount = 1;

  public constructor(
    private readonly data: {
      attributes?: Nillable<AdminCosmeticAttributes>;
      characteristics?: Nillable<AdminCosmeticCharacteristics>;
      cosmeticBrandId?: Nillable<Guid>;
      featuredFile?: Nillable<AdminMultimediaImageUpload>;
      files?: Nillable<AdminMultimediaImageUpload[]>;
      name: string;
      price?: Nillable<number>;
      slug?: Nillable<string>;
      status: AdminCosmeticStatus;
      vendorUrl?: Nillable<string>;
      warehouseProductId?: Nillable<Guid>;
      canBeWarehouseProductIdEdited?: Nillable<boolean>;
      id?: Nillable<Guid>;
    },
  ) {}

  public get name(): string {
    return this.data.name;
  }

  public get slug(): Nillable<string> {
    return this.data.slug;
  }

  public get cosmeticBrandId(): Nillable<Guid> {
    return this.data.cosmeticBrandId;
  }

  public get warehouseProductId(): Nillable<Guid> {
    return this.data.warehouseProductId;
  }

  public get featuredFile(): Nillable<AdminMultimediaImageUpload> {
    return this.data.featuredFile;
  }

  public get vendorUrl(): Nillable<string> {
    return this.data.vendorUrl;
  }

  public get files(): Nillable<AdminMultimediaImageUpload[]> {
    return this.data.files;
  }

  public get characteristics(): Nillable<AdminCosmeticCharacteristics> {
    return this.data.characteristics;
  }

  public get attributes(): Nillable<AdminCosmeticAttributes> {
    return this.data.attributes;
  }

  public get price(): Nillable<number> {
    return this.data.price;
  }

  public get status(): AdminCosmeticStatus {
    return this.data.status;
  }

  public get canBeWarehouseProductIdEdited(): Nillable<boolean> {
    return this.data.canBeWarehouseProductIdEdited;
  }

  public get id(): Nillable<Guid> {
    return this.data.id;
  }
}

export type AdminCosmeticDetailsFormGroup = FormGroup<{
  attributes: FormControl<Nillable<AdminCosmeticAttributes>>;
  characteristics: FormControl<Nillable<AdminCosmeticCharacteristics>>;
  cosmeticBrandId: FormControl<Nillable<Guid>>;
  featuredFile: FormControl<Nillable<AdminMultimediaImageUpload>>;
  files: FormControl<Nillable<AdminMultimediaImageUpload[]>>;
  name: FormControl<string>;
  price: FormControl<Nillable<number>>;
  slug: FormControl<Nillable<string>>;
  status: FormControl<Nillable<AdminCosmeticStatus>>;
  vendorUrl: FormControl<Nillable<string>>;
  warehouseProductId: FormControl<Nillable<Guid>>;
}>;
